import { render, staticRenderFns } from "./FilterRating.vue?vue&type=template&id=7ab6f16c&scoped=true&lang=pug&"
import script from "./FilterRating.vue?vue&type=script&lang=js&"
export * from "./FilterRating.vue?vue&type=script&lang=js&"
import style0 from "./FilterRating.vue?vue&type=style&index=0&id=7ab6f16c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab6f16c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VMenu,VSpacer})
